import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, createCommentVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["width", "height"];
const _hoisted_3 = ["fill"];
const _hoisted_4 = {
  fill: "currentColor",
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
};
const _hoisted_5 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcSavingIndicatorIcon",
  props: {
    size: { default: 20 },
    name: { default: "" },
    saving: { type: Boolean, default: false },
    error: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props) {
    const props = __props;
    const indicatorColor = computed(() => {
      if (props.error) {
        return "var(--color-text-error, var(--color-error))";
      }
      if (props.saving) {
        return "var(--color-primary-element)";
      }
      return "none";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        "aria-label": _ctx.name,
        class: "material-design-icon",
        role: "img",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
      }, [
        (openBlock(), createElementBlock("svg", {
          class: "material-design-icon__svg",
          width: _ctx.size,
          height: _ctx.size,
          viewBox: "0 0 24 24"
        }, [
          createElementVNode("path", {
            fill: indicatorColor.value,
            d: "m19 15a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4z"
          }, null, 8, _hoisted_3),
          createElementVNode("path", _hoisted_4, [
            _ctx.name ? (openBlock(), createElementBlock("title", _hoisted_5, toDisplayString(_ctx.name), 1)) : createCommentVNode("", true)
          ])
        ], 8, _hoisted_2))
      ], 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcSavingIndicatorIcon.vue_vue_type_script_setup_true_lang-CA0r_04W.mjs.map
